// =============================================================================================================
// External Connection Hooks
// =============================================================================================================
import { useCallback } from 'react';
import { useStytchCreateExternalConnection, useStytchUpdateExternalConnection, } from '../../../../services/stytch/client';
export function useCreateExternalConnection() {
    const createExternalConnection = useStytchCreateExternalConnection();
    return useCallback(async (data) => {
        const result = await createExternalConnection(data);
        if (result.success) {
            return {
                success: true,
                statusCode: result.statusCode,
                connection: result.connection,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [createExternalConnection]);
}
export function useUpdateExternalConnection() {
    const updateExternalConnection = useStytchUpdateExternalConnection();
    return useCallback(async (data) => {
        const result = await updateExternalConnection(data);
        if (result.success) {
            return {
                success: true,
                statusCode: result.statusCode,
                connection: result.connection,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [updateExternalConnection]);
}
